import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'app',
    component: () => import('../views/RouterWrapper.vue')
  }
]

const router = createRouter({
  history: createWebHistory('/CX/ceeac/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（比如浏览器前进后退），返回到保存的位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则滚动到页面顶部
    return { top: 0 }
  }
})

// 路由守卫：确保所有页面都通过根路径访问
router.beforeEach((to, from, next) => {
  // 如果访问的不是根路径，重定向到根路径并保持查询参数
  if (to.path !== '/') {
    next({
      path: '/',
      query: to.query
    })
    return
  }

  next()
})

// 暴露router实例供其他工具使用
window.__VUE_ROUTER_INSTANCE__ = router

export default router
